import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import clsx from "clsx";
import PropTypes from "prop-types";

const useStyles = makeStyles(theme => ({
    root: {
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2)
    },
    rootVertical: {
        flexDirection: 'column',
        width: 'auto',
        marginLeft: theme.spacing(2),
        marginRight: theme.spacing(2),
        marginTop: 0,
        marginBottom: 0
    },
    lineDiv: {
        flexGrow: 1,
        borderBottom: '1px solid ' + theme.palette.secondary.main
    },
    lineVerticalDiv: {
        borderRight: '1px solid ' + theme.palette.secondary.main,
        '&:first-child': {
            marginBottom: theme.spacing()
        },
        '&:last-child': {
            marginTop: theme.spacing()
        }
    },
    span: {
        color: theme.palette.secondary.main,
        display: 'block',
        marginRight: theme.spacing(),
        marginLeft: theme.spacing()
    }
}));

export default function Separator(props) {
    const {
        orientation = 'horizontal',
        text = 'ou',
        noCenterText = false
    } = props;
    const classes = useStyles();

    return (
        <div className={clsx(classes.root, orientation === 'vertical' && classes.rootVertical)}>
            <div className={clsx(classes.lineDiv, orientation === 'vertical' && classes.lineVerticalDiv)} />
            {!noCenterText && (
                <>
                    <span className={classes.span}>{text}</span>
                    <div className={clsx(classes.lineDiv, orientation === 'vertical' && classes.lineVerticalDiv)} />
                </>
            )}
        </div>
    );
};

Separator.propTypes = {
    orientation: PropTypes.string,
    text: PropTypes.string,
    noCenterText: PropTypes.bool
};